import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, formatApiError } from "../../lib/api";
import { CATEGORIES } from "../../constants/site";

const EMPTY = { name: "", category: CATEGORIES[0], price: "", stock: 10, image: "", description: "", specs: "", featured: false, badge: "" };

export const ProductForm = ({ product, open, onClose, onSaved }) => {
  const [form, setForm] = useState(() => product ? { ...product, specs: (product.specs || []).join(", ") } : EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const payload = { ...form, price: Number(form.price), stock: Number(form.stock), specs: form.specs.split(",").map((s) => s.trim()).filter(Boolean) };
    delete payload.id; delete payload.created_at;
    try {
      if (product?.id) await api.put(`/products/${product.id}`, payload);
      else await api.post("/products", payload);
      toast.success(product ? "Produit mis à jour" : "Produit ajouté");
      onSaved();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="product-form-dialog" aria-describedby={undefined} className="max-w-2xl sm:rounded-none">
        <DialogHeader><DialogTitle className="font-display text-navy">{product ? "Modifier le produit" : "Nouveau produit"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-5 sm:grid-cols-2">
          <input data-testid="pf-name" required value={form.name} onChange={set("name")} placeholder="Nom *" className="field sm:col-span-2" />
          <select data-testid="pf-category" value={form.category} onChange={set("category")} className="field">{CATEGORIES.map((c) => <option key={c}>{c}</option>)}</select>
          <input data-testid="pf-price" required type="number" min="0" value={form.price} onChange={set("price")} placeholder="Prix (F CFA) *" className="field" />
          <input data-testid="pf-stock" required type="number" min="0" value={form.stock} onChange={set("stock")} placeholder="Stock *" className="field" />
          <input data-testid="pf-image" required value={form.image} onChange={set("image")} placeholder="URL de l'image *" className="field" />
          <textarea data-testid="pf-description" required rows={3} value={form.description} onChange={set("description")} placeholder="Description *" className="field resize-none sm:col-span-2" />
          <input data-testid="pf-specs" value={form.specs} onChange={set("specs")} placeholder="Caractéristiques (séparées par des virgules)" className="field sm:col-span-2" />
          <input data-testid="pf-badge" value={form.badge || ""} onChange={set("badge")} placeholder="Étiquette (ex. Seconde main)" className="field" />
          <label className="flex items-center gap-2 text-sm text-navy"><input data-testid="pf-featured" type="checkbox" checked={!!form.featured} onChange={set("featured")} className="accent-royal" /> Mettre en avant (Sélection)</label>
          <button data-testid="pf-submit" disabled={busy} className="btn-primary justify-center sm:col-span-2 disabled:opacity-60">{busy ? "Enregistrement…" : "Enregistrer"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
